import { render, staticRenderFns } from "./WidgetQualityOfLife.vue?vue&type=template&id=4efccb8f&scoped=true"
import script from "./WidgetQualityOfLife.vue?vue&type=script&lang=ts"
export * from "./WidgetQualityOfLife.vue?vue&type=script&lang=ts"
import style0 from "./WidgetQualityOfLife.vue?vue&type=style&index=0&id=4efccb8f&prod&scoped=true&lang=scss"
import style1 from "./WidgetQualityOfLife.vue?vue&type=style&index=1&id=4efccb8f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efccb8f",
  null
  
)

export default component.exports